import { render, staticRenderFns } from "./NotificationDateTimeFormatSetup.vue?vue&type=template&id=74e30b1a&scoped=true"
import script from "./NotificationDateTimeFormatSetup.vue?vue&type=script&lang=ts"
export * from "./NotificationDateTimeFormatSetup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e30b1a",
  null
  
)

export default component.exports